import React from 'react';
import { useSelector } from 'react-redux';
import Popup from '../../ui/popup/Popup';
import parsePromotionMetadata from '../../../utils/promotionUtils/parsePromotionMetadata';
import PromotionHeader from './PromotionHeader';
import PromotionContent from './PromotionContent';
import PromotionButtons from './PromotionButtons';
import PromotionNav from './promotionNav/PromotionNav';
import classes from './ContentPromotionPopup.module.css';

const ContentPromotionPopup = ({ promotion, onClose, onPrev, onNext, currentIndex = 0, totalCount = 1 }) => {

    const { texts } = useSelector(state => state.translate);
    const metadata = parsePromotionMetadata(promotion?.additionalInfo);
    const showNav = totalCount > 1;
    return (
        <Popup
            close={onClose}
            title={texts.promotionSystemTitle}
            dropClass={`${classes.Popup} ${showNav ? classes.PopupWithNav : ""}`}
            dropClassClose={classes.HiddenClose}
        >
            <PromotionHeader title={metadata?.title} onClose={onClose} />
            {promotion?.imageFile &&
                <PromotionContent contentType={metadata?.contentType} url={promotion?.imageFile} title={metadata?.title} />
            }
            {showNav &&
                <PromotionNav
                    currentIndex={currentIndex}
                    totalCount={totalCount}
                    onPrev={onPrev}
                    onNext={onNext}
                />
            }
            <PromotionButtons
                primaryButton={metadata.primaryButton}
                secondaryButton={metadata.secondaryButton}
                closeText={texts.close}
                onClose={onClose}
            />
        </Popup>
    );
};

export default ContentPromotionPopup;
